import React, { useState, useEffect } from 'react';
import { Box, Typography, Tabs, Tab, CircularProgress, Alert, Paper } from '@mui/material';
import AccountService from '../../../services/AccountService';
import AccountOverview from './AccountOverview';
import Invoices from './Invoices';
import AccountStatements from './AccountStatements';
import MyWallet from '../../Common/Wallet/MyWallet';
import Payments from './Payments';
import PendingPayments from './PendingPayments';
import RelatedTickets from './RelatedTickets';
import AccountSummary from './AccountSummary';

/**
 * TabPanel component for the tab content
 */
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`account-tabpanel-${index}`}
      aria-labelledby={`account-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

/**
 * Main Account Management component with tab navigation for account-related sections
 */
function AccountManagement() {
  const [tabValue, setTabValue] = useState(0);
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAccountData = async () => {
      setLoading(true);
      try {
        const accountData = await AccountService.getAccountOverview();
        setAccount(accountData);
        setError(null);
      } catch (err) {
        console.error('Error fetching account data:', err);
        setError('Failed to load account information. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchAccountData();
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom
        sx={{ fontFamily: 'Roboto, Arial, sans-serif', fontSize: '1.5rem', fontWeight: 500 }}
      >
        Account Management
      </Typography>
      
      {/* Replaced static summary with our new AccountSummary component */}
      <AccountSummary />
      {/* Removed tab navigation to make UI more compact */}
      
      {/* Display AccountOverview directly */}
    </Box>
  );
}

export default AccountManagement;
